var $609dbdfbcad85bdb$exports = {};
$609dbdfbcad85bdb$exports = {
    "removeButtonLabel": `Rimuovi`,
    "removeDescription": `Premi Elimina per rimuovere il tag.`
};


export {$609dbdfbcad85bdb$exports as default};
//# sourceMappingURL=it-IT.module.js.map
